module.exports = __webpack_public_path__ + "static/media/1.f7a1c6ad.jpg";